import type { InputFrame, MoveAxis } from '../player/stateMachine';

/** Combines input sources (keyboard, touch pad): any held direction/run counts, any jump edge counts. */
export function mergeInputs(...frames: readonly (InputFrame | null | undefined)[]): InputFrame {
  let left = false;
  let right = false;
  let runHeld = false;
  let jumpPressed = false;
  for (const f of frames) {
    if (!f) continue;
    if (f.moveAxis < 0) left = true;
    if (f.moveAxis > 0) right = true;
    runHeld = runHeld || f.runHeld;
    jumpPressed = jumpPressed || f.jumpPressed;
  }
  const moveAxis: MoveAxis = left === right ? 0 : left ? -1 : 1;
  return { moveAxis, runHeld, jumpPressed };
}
